import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "userFormContent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", {
  class: "fs24 ls1 mc fw600",
  style: {"margin-top":"40px"}
}, "ユーザー登録情報の確認", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "centered w100"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { class: "centered" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "企業アカウントとしてご登録された場合は、同じメールアドレスで構いません。", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "企業（グループ）で統一したURLを設定します。半角英数字（3文字以上）が使用可能です。", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs18 fl grey",
  style: {"margin-top":"27px"}
}, "https://waaq.jp/p/", -1)
const _hoisted_37 = {
  class: "fl ml5",
  style: {"width":"280px"}
}
const _hoisted_38 = {
  class: "fl",
  style: {"line-height":"70px"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 1,
  class: "fs11 green fw600"
}
const _hoisted_41 = {
  key: 2,
  class: "fl fs11 alertRed fw600"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" ご職業 "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 所属部門名/部署名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" あなたの日程調整件数（月当たり）    "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 会社規模    "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 貴社全体の日程調整件数（月当たり）    "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "社内の人のみの社内会議を除いた件数を教えて下さい。")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 日程調整で課題や改善したいことなどありましたら、ご記入ください。    "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" waaqLinkをどこで知りましたか？    "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "必須")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = { class: "fl w65" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_74 = { key: 0 }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "md-error" }, "選択してください。", -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, [
  /*#__PURE__*/_createTextVNode(" ホームページもしくはLP(ランディングページ)のURLを教えてください。 "),
  /*#__PURE__*/_createElementVNode("span", { class: "label skyblueBorder" }, "任意")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "centered mt20" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/tos",
    target: "_blank",
    class: "dgrey"
  }, "利用規約"),
  /*#__PURE__*/_createTextVNode("・"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/privacy_policy",
    target: "_blank",
    class: "dgrey"
  }, "プライバシーポリシー"),
  /*#__PURE__*/_createTextVNode("に同意し、 ")
], -1)
const _hoisted_84 = { class: "mc centered" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_86 = { key: 2 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = [
  _hoisted_87,
  _hoisted_88,
  _hoisted_89,
  _hoisted_90
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButtonTag = _resolveComponent("RadioButtonTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_RangefieldTag = _resolveComponent("RangefieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_ctx.rm.userInfo && _ctx.page == 1)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "formContent",
          style: {"text-align":"left"},
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (_ctx.rm.userInfo.group_status >= _ctx.Const.STATUS_CONFIRMED())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.rm.userInfo.is_company)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createTextVNode(" 招待元:   "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.rm.userInfo.company_name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11)),
          _hoisted_12,
          (_ctx.Const.STATUS_BEFORE_CONFIRM(_ctx.rm.userInfo.group_status))
            ? (_openBlock(), _createBlock(_component_RadioButtonTag, {
                key: 2,
                options: [
                    { name: `企業アカウントです`, id: `company` },
                    { name: `個人アカウントです`, id: `personal` },
                ],
                optionName: `account_type`,
                defaultOption: `company`,
                type: `horizon`,
                onSelect: _ctx.selectAccountType,
                style: {"margin-top":"3px"}
              }, null, 8, ["onSelect"]))
            : _createCommentVNode("", true),
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _createVNode(_component_MdTextfieldTag, {
            name: "氏名 （あなたのお名前を入力してください。）",
            fieldStyle: "min-width:280px;max-width:100%;",
            style: {"height":"56px","min-width":"280px","max-width":"100%"},
            class: "fl fs16",
            type: `name`,
            value: _ctx.rm.userInfo.name,
            onInputValue: _ctx.inputUserName,
            onBlur: _ctx.checkName,
            errMessage: _ctx.validName ? null : `氏名を入力してください。`,
            required: ""
          }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
          _hoisted_16,
          _hoisted_17,
          (_ctx.rm.userInfo.group_status < _ctx.Const.STATUS_CONFIRMED())
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_MdTextfieldTag, {
                  name: "企業名 / 所属名",
                  fieldStyle: "min-width:280px;max-width:100%;",
                  style: {"height":"56px","min-width":"280px","max-width":"100%"},
                  class: "fl fs16",
                  type: `companyName`,
                  value: _ctx.rm.userInfo.company_name,
                  onInputValue: _ctx.inputCompanyName,
                  onBlur: _ctx.checkCompanyName,
                  errMessage: _ctx.validCompanyName ? null : `所属名を入力してください。`,
                  required: ""
                }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                _hoisted_19,
                _hoisted_20,
                _hoisted_21
              ]))
            : _createCommentVNode("", true),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            (_ctx.rm.userInfo.group_status >= _ctx.Const.STATUS_CONFIRMED())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "submit",
                  class: "pointer mc centered circle_button skyblueBg registerUserInfoButton",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                }, " 登録 "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "submit",
                  class: "pointer mc centered circle_button skyblueBg registerUserInfoButton",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                }, " 次へ "))
          ])
        ], 32))
      : (_ctx.rm.userInfo && _ctx.page == 2)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "formContent",
            style: {"text-align":"left"},
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_MdTextfieldTag, {
              name: "ご連絡先（電話番号）",
              value: this.sections[`10000`],
              fieldStyle: "min-width:280px;max-width:100%;",
              style: {"height":"56px","min-width":"280px","max-width":"100%"},
              class: "fl fs16",
              type: `tel`,
              onInputValue: _ctx.inputTel,
              errMessage: _ctx.validTel ? null : `ご連絡先を入力してください。`,
              required: ""
            }, null, 8, ["value", "onInputValue", "errMessage"]),
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _createVNode(_component_MdTextfieldTag, {
              name: "企業メールアドレス",
              placeholder: "wakuta@company.com",
              fieldStyle: "min-width:280px;max-width:100%;",
              style: {"height":"56px","min-width":"280px","max-width":"100%"},
              class: "fl fs16",
              type: `companyMail`,
              value: this.sections[`10001`],
              onInputValue: _ctx.inputCompanyMail,
              errMessage: _ctx.validCompanyMail ? null : `企業メールアドレスを入力してください。`,
              required: ""
            }, null, 8, ["value", "onInputValue", "errMessage"]),
            _hoisted_31,
            _hoisted_32,
            _hoisted_33,
            _hoisted_34,
            _hoisted_35,
            _createElementVNode("div", null, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_MdTextfieldTag, {
                  fieldStyle: "min-width:280px;max-width:100%;font-weight:600;",
                  style: {"height":"56px","min-width":"280px","max-width":"100%"},
                  class: "fl fs16",
                  type: `namespace`,
                  placeholder: `waaq`,
                  value: _ctx.namespace,
                  onInputValue: _ctx.inputNamespace,
                  onBlur: _ctx.checkNamespace,
                  errMessage: _ctx.validNamespace ? null : `入力してください。`,
                  required: ""
                }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                (_ctx.canRegister === undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, " "))
                  : (_ctx.canRegister)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, "✔ 登録できます"))
                    : (_ctx.Util.isPresent(_ctx.ngReasons))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ngReasons, (ngMessage) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: ngMessage,
                              class: "alertRed fw600 fs11"
                            }, _toDisplayString(ngMessage), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _hoisted_42
            ]),
            _hoisted_43,
            _hoisted_44,
            _createElementVNode("div", null, [
              _hoisted_45,
              _hoisted_46,
              _createVNode(_component_MdTextfieldTag, {
                placeholder: "法人営業（できるだけ詳しくご記入ください）",
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16",
                type: `occupation`,
                value: this.additionalInfo[`occupation`],
                onInputValue: _ctx.inputOccupation,
                errMessage: _ctx.validOccupation ? null : `ご職業を入力してください。`,
                required: ""
              }, null, 8, ["value", "onInputValue", "errMessage"]),
              _hoisted_47,
              _hoisted_48
            ]),
            _createElementVNode("div", null, [
              _hoisted_49,
              _hoisted_50,
              _createVNode(_component_MdTextfieldTag, {
                placeholder: "営業部",
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16",
                type: `department`,
                value: _ctx.sections[`10004`],
                onInputValue: _ctx.inputDepartment,
                errMessage: _ctx.validDepartment ? null : `所属部門名/部署名を入力してください。`,
                required: ""
              }, null, 8, ["value", "onInputValue", "errMessage"]),
              _hoisted_51,
              _hoisted_52
            ]),
            _hoisted_53,
            _createVNode(_component_RangefieldTag, {
              options: [
                    { name: `1-10件`, id: `1` },
                    { name: `11-20件`, id: `11` },
                    { name: `21-30件`, id: `21` },
                    { name: `31-50件`, id: `31` },
                    { name: `51件-`, id: `51` },
                ],
              optionName: `selectYourScheduleNumPM`,
              defaultId: `1`,
              type: `horizon`,
              style: {"margin-top":"13px"},
              onSelect: _ctx.selectYourScheduleNumPM
            }, null, 8, ["onSelect"]),
            _hoisted_54,
            _hoisted_55,
            _hoisted_56,
            _hoisted_57,
            _createVNode(_component_RangefieldTag, {
              options: [
                    { name: `1-5人`, id: `1` },
                    { name: `6-10人`, id: `6` },
                    { name: `11-50人`, id: `11` },
                    { name: `51-100人`, id: `51` },
                    { name: `101-1000人`, id: `101` },
                    { name: `1001人-`, id: `1001` },
                ],
              optionName: `selectUserNumPerCompany`,
              defaultId: `1`,
              type: `horizon`,
              style: {"margin-top":"13px"},
              onSelect: _ctx.selectUserNumPerCompany
            }, null, 8, ["onSelect"]),
            _hoisted_58,
            _hoisted_59,
            _hoisted_60,
            _hoisted_61,
            _createVNode(_component_RangefieldTag, {
              options: [
                    { name: `1-100件`, id: `1` },
                    { name: `101-300件`, id: `101` },
                    { name: `301-500件`, id: `301` },
                    { name: `501-1000件`, id: `501` },
                    { name: `1001件-`, id: `1001` },
                ],
              optionName: `selectCompanyScheduleNumPM`,
              defaultId: `1`,
              type: `horizon`,
              style: {"margin-top":"13px"},
              onSelect: _ctx.selectCompanyScheduleNumPM
            }, null, 8, ["onSelect"]),
            _hoisted_62,
            _hoisted_63,
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _createVNode(_component_TextareaTag, {
              placeholder: "日程調整が煩雑すぎてどうにかしたい",
              style: {"height":"100px","min-width":"280px","max-width":"100%"},
              class: "fl fs14 roundForm w100",
              value: _ctx.content,
              onInputValue: _ctx.inputContent,
              required: ""
            }, null, 8, ["value", "onInputValue"]),
            _hoisted_67,
            _hoisted_68,
            _hoisted_69,
            _createElementVNode("div", null, [
              _hoisted_70,
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_SelectTag, {
                  name: "mail_style",
                  id: "mail_style",
                  class: "fl fs14 roundForm",
                  style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                  options: _ctx.SelectUtil.whyDoyouKnowUsTypes.map(m => m.name),
                  needUnselect: true,
                  defaultOption: null,
                  onSelectValue: _ctx.selectWhyDoyouKnowUsType
                }, null, 8, ["options", "onSelectValue"])
              ]),
              _hoisted_73,
              (!_ctx.validWhyDoyouKnowUsType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                : _createCommentVNode("", true),
              _hoisted_77,
              _hoisted_78
            ]),
            _createElementVNode("div", null, [
              _hoisted_79,
              _hoisted_80,
              _createVNode(_component_MdTextfieldTag, {
                placeholder: "https://www.example.com",
                fieldStyle: "min-width:280px;max-width:100%;",
                style: {"height":"56px","min-width":"280px","max-width":"100%"},
                class: "fl fs16",
                type: `homepage_url`,
                value: _ctx.sections[`10003`],
                onInputValue: _ctx.inputHomepageUrl
              }, null, 8, ["value", "onInputValue"]),
              _hoisted_81,
              _hoisted_82
            ]),
            _hoisted_83,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "pointer mc centered circle_button skyblueBg registerUserInfoButton fw600",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendUserInfo && _ctx.sendUserInfo(...args)))
                }, " この内容で登録する ")
              ])
            ])
          ], 32))
        : _createCommentVNode("", true),
    _hoisted_85,
    (_ctx.isSP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_91))
      : _createCommentVNode("", true)
  ]))
}